
import {
    Box,
    Backdrop,
    CircularProgress
} from '@mui/material';

export function CustomTitle(title) {
    if (title) {
        return title.split(/[\s_]/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
    return title;
}

export function getYesterdayDate() {
    const yesterday = new Date();
    yesterday.setUTCDate(yesterday.getUTCDate() - 1);
    const utcYesterday = yesterday.toISOString();
    return utcYesterday;
}

export function SectionBox({ height, title, children, bgcolor = "white", fontWeight = 400, minWidth = "0px" }) {
    return (
        <Box
            height={height}
            sx={{
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                padding: 2,
                backgroundColor: "white",
                position: "relative",
                bgcolor: bgcolor,
                // width:"98%"
                minWidth: minWidth
            }}
        >
            <Box
                sx={{
                    bgcolor: bgcolor,
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: 1,
                    // backgroundColor: "white",
                    position: "absolute",
                    top: -15,
                    left: 30,
                    fontSize: "13px",
                    fontWeight: fontWeight,
                    px: 2,
                    py: 0.5,
                }}
            >
                {title}
            </Box>
            <Box>{children}</Box>
        </Box>
    );
}

export function Loader({ loading }) {
    return (
        <Backdrop
            open={loading}
            sx={(theme) => ({
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            })}
        >
            <CircularProgress />
        </Backdrop>
    );
}

export function getFilteredData(value, originalData, excludedKeys = ["CorporationID"]) {
    if (!value) return originalData;

    return originalData.filter((item) =>
        Object.entries(item).some(([key, val]) =>
            !excludedKeys.includes(key) &&
            String(val).toLowerCase().includes(value.toLowerCase())
        )
    );
};


export async function handleSessionOut() {
    const name = "sessionout";
    window.parent.postMessage(name, "*");
    await new Promise(resolve => setTimeout(resolve, 500));
};

// This is for getEST timing to show in pdf (/generatepdf)
export const getESTTime = () => {
    return new Date()
        .toLocaleString("en-US", {
            timeZone: "America/New_York",
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
        })
        .replace(",", "");
};





